import { Delete } from '@mui/icons-material';
import React from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';

function DeleteModal(props) {
  const { deleteModal, handleDeleteReport, closeModal, loading, text, history } = props;
  return (
    <Modal show={deleteModal} onHide={closeModal} centered>
      <Modal.Body className="text-center py-4">
        <Delete
          sx={{
            fontSize: '40px',
          }}
          className="text-danger"
        />
        <h3 className="base-color my-2">Are you sure?</h3>
        {!history && (
          <p className="mb-0 fs-5 text-secondary">Do you really want to delete the {(text && text) || 'report'}?</p>
        ) || <p className="mb-0 fs-5 text-secondary">{text}</p>}
        {!history && <p className="mb-0 fs-5 text-secondary">This record can not be restored.</p>}
        <Row>
          <Col className="mt-4">
            <Button variant="outline-secondary" className="me-2" onClick={closeModal}>
              Cancel
            </Button>
            <Button variant="outline-danger" onClick={handleDeleteReport} disabled={loading}>
              {(history && 'Assign') || 'Delete'}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default DeleteModal;
